import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { checkAndRefreshToken } from 'utils/authUtils';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const categoryApi = createApi({
  reducerPath: 'category',

  baseQuery: createBaseQueryWithReauth('/dictionaries'),

  refetchOnMountOrArgChange: true,
  refetchOnReconnect: false,
  keepUnusedDataFor: 1,

  endpoints: builder => ({
    fetchCategories: builder.query({
      query: () => '/categories',
    }),
    fetchPrices: builder.query({
      query: () => '/bag-prices',
    }),
    fetchBagStatuses: builder.query({
      query: () => '/bag-statuses',
    }),
    fetchOrderStatuses: builder.query({
      query: () => '/order-statuses',
    }),
    fetchDishOrderStatuses: builder.query({
      query: () => '/dish-order-statuses',
    }),
    fetchOrganisationTypes: builder.query({
      query: () => '/organization-types',
    }),
      fetchDiscountPercent: builder.query({
      query: () => '/dishes-discount-percent',
    }),
  }),
});
export const {
  useFetchCategoriesQuery,
  useFetchPricesQuery,
  useFetchBagStatusesQuery,
  useFetchDishOrderStatusesQuery,
  useFetchOrderStatusesQuery,
  useFetchOrganisationTypesQuery,
useFetchDiscountPercentQuery
} = categoryApi;
